// import SingleCard from "./SingleCard";
// import WasteSummary from "./WasteSummary";

// import FetchWrapper from "@/components/reusables/FetchWrapper";
// import { useGetParams } from "@/hooks/useGetParams";
// import { WasteSummary as IWasteSummary } from "@/interfaces/interfaces";
// import MaterialComposition from "@/pages/waste-management/summary/components/material-composition";
// import RecoveryBreakdown from "@/pages/waste-management/summary/components/recovery-breakdown";
// import ResourceRecovery from "@/pages/waste-management/summary/components/resource-recovery";
// import { useGetSummaryReportQuery } from "@/redux/api/waste-management";

// const ReportSummary = (): React.JSX.Element => {
//   const params = useGetParams(["rowId", "fortnight"]);
//   const subparams = params.substring(1).replace("rowId", "id");

//   const { data: s, ...rest } = useGetSummaryReportQuery(subparams);

//   const summaryData = s as IWasteSummary | null | undefined;

//   return (
//     <FetchWrapper {...rest}>
//       <div className='space-y-8'>
//         <WasteSummary />

//         {summaryData === null ? (
//           <></>
//         ) : (
//           <>
//             <div className='grid grid-cols-5 gap-4 '>
//               <SingleCard title='Recycled Waste' value='2687.97' />
//               <SingleCard title='Landfill Waste' value='70948.48' />
//               <SingleCard title='Total Waste' value='83883.00' />
//               <SingleCard title='No of Projects' value='15' />
//               <SingleCard title='No of Waste Type' value='2' />
//             </div>
//             <FetchWrapper {...rest}>
//               <MaterialComposition
//                 composition={
//                   summaryData ? (summaryData?.wasteComposition as object) : {}
//                 }
//               />
//               <ResourceRecovery
//                 resourceRecoveryDetails={
//                   summaryData
//                     ? (summaryData?.detailedWasteComposition as object)
//                     : {}
//                 }
//               />
//               <RecoveryBreakdown
//                 recoveryBreakDown={
//                   summaryData ? (summaryData?.recoveryBreakDown as object) : {}
//                 }
//               />
//             </FetchWrapper>
//           </>
//         )}
//       </div>
//     </FetchWrapper>
//   );
// };

// export default ReportSummary;

import React, { useState } from "react";

import WasteManageSummary from "@/pages/waste-management/summary/components/summary";

const ReportSummary = (): React.JSX.Element => {
  const [_showExport, setShowExport] = useState<boolean>(true);

  return <WasteManageSummary setShowExport={setShowExport} />;
};

export default ReportSummary;
